'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSearchSuggestions = exports.getSearchSuggestions = exports.SEARCH_SUGGESTIONS_SUCCESS = exports.SEARCH_SUGGESTIONS_REQUEST = exports.SEARCH_SUGGESTIONS_FAIL = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SEARCH_SUGGESTIONS_FAIL = exports.SEARCH_SUGGESTIONS_FAIL = 'la/ui/searchSuggestions/FAIL';
var SEARCH_SUGGESTIONS_REQUEST = exports.SEARCH_SUGGESTIONS_REQUEST = 'la/ui/searchSuggestions/REQUEST';
var SEARCH_SUGGESTIONS_SUCCESS = exports.SEARCH_SUGGESTIONS_SUCCESS = 'la/ui/searchSuggestions/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
    suggestions: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SEARCH_SUGGESTIONS_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case SEARCH_SUGGESTIONS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true,
                suggestions: (0, _cloneDeep2.default)(action.payload)
            });
        case SEARCH_SUGGESTIONS_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.searchSuggestions;
};

var getUiSearchSuggestions = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getSearchSuggestions = exports.getSearchSuggestions = (0, _reselect.createSelector)(getUiSearchSuggestions, function (uiSearchSuggestions) {
    return [].concat((0, _toConsumableArray3.default)(uiSearchSuggestions.suggestions));
});

/* ACTION CREATORS */
var searchSuggestionsFail = function searchSuggestionsFail(term, error) {
    return {
        error: true,
        meta: { term: term },
        payload: error,
        type: SEARCH_SUGGESTIONS_FAIL
    };
};

var searchSuggestionsRequest = function searchSuggestionsRequest(term) {
    return {
        payload: term,
        type: SEARCH_SUGGESTIONS_REQUEST
    };
};

var searchSuggestionsSuccess = function searchSuggestionsSuccess(suggestions) {
    return {
        payload: suggestions,
        type: SEARCH_SUGGESTIONS_SUCCESS
    };
};

var fetchSearchSuggestions = exports.fetchSearchSuggestions = function fetchSearchSuggestions(term) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(searchSuggestionsRequest(term));
        return _api.SearchSuggestions.fetchSuggestions({ deployment: deployment, term: term }).then(function (response) {
            dispatch(searchSuggestionsSuccess(response.suggestions));
        }).catch(function (error) {
            dispatch(searchSuggestionsFail(term, error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/searchSuggestions.js
// module id = I7EN
// module chunks = 57